import type { ChartSeriesDefaults, SeriesIdentity } from "../../components/dataGrid/chartSeriesState.ts";

/**
 * Series shown by default on the kiosk temperature charts. Each IQ box reports several sensors,
 * and sensor 0 is its main temperature probe. Web_Admin_Kiosk_Temperature_FN names a series
 * "Kiosk {id}, series {PiID}.{SensorKey}" (or "Kiosk {id}, {IQ box name} (series {PiID}.{SensorKey})")
 * and keys it "{KioskID}.{PiID}.{SensorKey}.{Metric}" — either tells us the sensor number.
 * PiID is a signed int: hardware serials above 2^31 are stored negative ("series -677216759.0").
 */
const MAIN_SENSOR_NAME = /series\s+-?\d+\.0(?!\d)/i;
const MAIN_SENSOR_KEY = /^-?\d+\.-?\d+\.0\.[A-Za-z]+$/;

export function isMainSensorSeries(series: SeriesIdentity): boolean {
  return MAIN_SENSOR_NAME.test(series.name) || MAIN_SENSOR_KEY.test(series.key ?? "") || MAIN_SENSOR_NAME.test(series.key ?? "");
}

/** Sensor charts: main sensors (".0") visible by default, others one click away, stable order. */
export const TEMPERATURE_SENSOR_SERIES: ChartSeriesDefaults = {
  isDefaultVisible: isMainSensorSeries,
  defaultLabel: "Main sensors",
  sortByName: true,
};

/** Median charts: one series per kiosk, so everything stays visible; just keep the order stable. */
export const TEMPERATURE_MEDIAN_SERIES: ChartSeriesDefaults = { sortByName: true };

/** The defaults for one of the four temperature chart grids. */
export function temperatureSeriesDefaults(gridName: string): ChartSeriesDefaults {
  return gridName.toLowerCase().startsWith("kiosktemperaturemedian") ? TEMPERATURE_MEDIAN_SERIES : TEMPERATURE_SENSOR_SERIES;
}
